import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft } from "lucide-react";
import api, { formatApiErrorDetail } from "@/config/api";
import { GamifiedButton } from "@/components/GamifiedButton";
import { Logo } from "@/components/Logo";
import { ErrorMessage } from "@/components/Feedback";
import { useSeo } from "@/hooks/useSeo";

export default function ForgotPassword() {
  useSeo("Mot de passe oublié", "Réinitialise ton mot de passe Quran Coach et reprends ton apprentissage du Coran en toute sécurité.");
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 islamic-bg">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-[0_10px_40px_rgba(0,0,0,0.06)] p-8 border border-slate-100">
        <div className="flex justify-center mb-6"><Logo size="lg" /></div>
        <h1 className="text-2xl font-black text-slate-800 mb-1 text-center">Mot de passe oublié</h1>
        <p className="text-slate-500 mb-6 text-center text-sm">Entre ton email pour recevoir un lien de réinitialisation.</p>

        {error && <div className="mb-4"><ErrorMessage message={error} /></div>}

        {sent ? (
          <div className="bg-emerald-50 border border-emerald-100 text-emerald-700 rounded-2xl p-4 text-sm font-semibold text-center" data-testid="reset-sent">
            Si un compte existe, un lien a été envoyé. (En démo, le lien s'affiche dans les logs du serveur.)
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
              <input data-testid="forgot-email" type="email" required placeholder="Adresse email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-12 pr-4 py-3.5 rounded-2xl border-2 border-slate-200 focus:border-primary outline-none font-semibold" />
            </div>
            <GamifiedButton type="submit" disabled={loading} className="w-full" data-testid="forgot-submit">
              {loading ? "Envoi…" : "Envoyer le lien"}
            </GamifiedButton>
          </form>
        )}

        <Link to="/login" className="flex items-center justify-center gap-1 text-sm font-bold text-primary hover:underline mt-6">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
